import { filterMap } from 'utils/array';

import { useAllTemplateQueryValidations } from './useAllTemplateQueryValidations';

export const useTemplateQueriesWithErrors = (templateId: string | undefined) => {
  const { data: allTemplateQueryValidations } = useAllTemplateQueryValidations(templateId);

  if (!allTemplateQueryValidations) {
    return [];
  }

  return filterMap(allTemplateQueryValidations, ({ validationErrors, queryId }) => {
    return Object.keys(validationErrors).length > 0 ? queryId : undefined;
  });
};
